module.exports = __webpack_public_path__ + "img/chat_avatar_ava_dark.8b40edbf.png";